var _linearGradient, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessPlanning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 200 198.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "pp-business-planning--lg-1",
    x1: 123.1243,
    x2: 31.1506,
    y1: 20.7239,
    y2: 179.9857,
    gradientTransform: "matrix(1 0 0 -1 0 200)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b17ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098aed"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.6 168.6l46.2-118.2c6.8-16.4-3-33.2-20.4-35.4L54.2 0c-13 0-23.6 10.6-23.6 23.6 0 4.1 1.1 8.2 3.2 11.8l76.9 133.2c6.5 11.3 21 15.2 32.3 8.6 3.5-2 6.5-5 8.6-8.6z",
    fill: "#41d3bd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.3 47.6C116.8 32.7 91.1 18 65.4 3.3 58.8-.5 51.7-1.1 44.7 2.2L43 3l-.6.3C34.7 7.7 30.3 14.2 30 23.1c-.3 7.9-.1 15.9-.1 23.8 0 8.2 0 16.3-.1 24.5v19.7c0 6.6.1 13.4 0 20.1-.1 9.7 3.8 17.2 12.3 22.1 25.4 14.7 50.8 29.3 76.2 43.9 5.4 3.1 11.8 4 17.9 2.6l4.5-2.1 1.6-.9c7.2-4.3 11.3-10.8 11.6-19.2.3-8.8.1-17.7.1-26.5V98.5c0-9.7-.1-19.4 0-29.2.1-9.5-3.6-16.9-11.7-21.7z",
    fill: "#41d3bd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#098aed",
    d: "M112.6 66.1C87 51.2 61.3 36.4 35.7 21.7 29 17.9 22 17.3 15 20.6c-.6.3-1.1.5-1.7.8l-.6.4C4.9 26.2.5 32.7.2 41.5 0 49.5.1 57.4.1 65.4c0 8.2 0 16.3-.1 24.5v19.7c0 6.6.1 13.4 0 20.1-.1 9.7 3.8 17.2 12.3 22.1 25.4 14.7 50.8 29.3 76.2 43.9 5.4 3.1 11.8 4 17.9 2.6l4.5-2.1 1.6-.9c7.2-4.3 11.3-10.8 11.6-19.2.3-8.8.1-17.6.1-26.5V117c0-9.7-.1-19.4 0-29.2.1-9.5-3.5-17-11.6-21.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pp-business-planning--lg-1)",
    d: "M112.6 66.1C87 51.2 61.3 36.4 35.7 21.7c-1.7-1-3.4-1.7-5.3-2.3-.2 1.2-.3 2.4-.4 3.7-.3 7.9-.1 15.9-.1 23.8 0 8.2 0 16.3-.1 24.5v19.7c0 6.6.1 13.4 0 20.1-.1 9.7 3.8 17.2 12.3 22.1 25.4 14.7 50.8 29.3 76.2 43.9 1.7 1 3.5 1.7 5.4 2.3.2-1.2.3-2.3.4-3.5.3-8.8.1-17.6.1-26.5v-32.6c0-9.7-.1-19.4 0-29.2.1-9.4-3.5-16.9-11.6-21.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessPlanning);
export default __webpack_public_path__ + "static/media/business-planning.bf3c777c.svg";
export { ForwardRef as ReactComponent };